// @flow

import { type UserInputValues } from '@tectonics/prs/user-input-values';
import { type OutgoingPayment } from '@tectonics/prs/outgoing-payment';

export function kenyanOutgoingPaymentMapper(userInputValues: UserInputValues): $Shape<OutgoingPayment> {
  return {
    country: 'ke',
    document: userInputValues['kenyanDocument'],
    zipcode: userInputValues['kenyanZipcode'],
    state: userInputValues['kenyanState'],
    city: userInputValues['kenyanCity'],
    address: userInputValues['kenyanAddress'],
    street_number: userInputValues['kenyanStreetNumber'],
    street_complement: userInputValues['kenyanStreetComplement'],
    phone_number: userInputValues['kenyanPhoneNumber'],
  };
}
